import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import axios from 'axios';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const [content, setContent] = React.useState('');
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    axios.get('/api/admin/settings/public?id=global')
      .then(res => {
        if (res.data?.success && res.data.settings?.privacy_policy) {
          setContent(res.data.settings.privacy_policy);
        }
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#F4ECDE] py-12 px-4 font-sans text-[#471F21]">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-12">
        {/* Header */}
        <button
          onClick={() => navigate('/')}
          className="flex items-center text-gray-600 hover:text-[#471F21] mb-8 transition-colors"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Back to Home
        </button>

        <div className="border-b-2 border-[#471F21]/10 pb-6 mb-8">
          <h1 className="text-3xl md:text-4xl font-serif font-bold mb-4">Privacy Policy</h1>
          <p className="text-gray-600">Effective Date: {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</p>
        </div>

        <div className="space-y-8 text-gray-700 leading-relaxed">
          {loading ? (
            <div className="text-center py-20 text-gray-400">Loading policy details...</div>
          ) : content ? (
            <div className="prose max-w-none prose-stone prose-headings:text-[#471F21] prose-a:text-[#8B4446]" dangerouslySetInnerHTML={{ __html: content }} />
          ) : (
            <div className="text-center py-10 text-gray-500">Policy not found.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

